import React from 'react';

import cn from 'classnames';

import cls from './Spinner.module.css';

interface SpinnerProps {
    classes?: string;
    width?: number;
    height?: number;
}

export const Spinner = ({ classes, height = 24, width = 24 }: SpinnerProps) => (
    <span className={cn(cls.loader, classes)}>
        <span style={{ width, height }} className={cls.defaultSpinner} aria-hidden="true" />
    </span>
);
